import {NotifyMessageDto} from '../../../global/api/generated-notifies-api';
import {AppNotification, NotificationMarkType} from '../types/notifications.types';

const DEFAULT_NOTIFICATION_MARK_TYPE: NotificationMarkType = 'READ';

const getNotificationTime = (value: string) => {
  const time = new Date(value).getTime();

  return Number.isNaN(time) ? 0 : time;
};

const normalizeMarkType = (value?: NotifyMessageDto['markType']): NotificationMarkType => {
  if (value === 'NEW' || value === 'READ' || value === 'DELETE') {
    return value;
  }

  return DEFAULT_NOTIFICATION_MARK_TYPE;
};

export const mapNotificationDto = (notification: NotifyMessageDto): AppNotification | null => {
  if (!notification.uid) {
    return null;
  }

  return {
    id: notification.uid,
    title: notification.title || 'Без заголовка',
    message: notification.message || '',
    createDate: notification.createDate || notification.updateDate || '',
    markType: normalizeMarkType(notification.markType),
  };
};

export const mapNotificationDtos = (notifications: NotifyMessageDto[]): AppNotification[] => {
  return notifications
    .map(mapNotificationDto)
    .filter((notification): notification is AppNotification => Boolean(notification))
    .sort((left, right) => getNotificationTime(right.createDate) - getNotificationTime(left.createDate));
};
